var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFilterGreen = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M0 0h24v24H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#06CA3D",
  d: "M11.127 19a.84.84 0 0 1-.622-.252.85.85 0 0 1-.25-.623v-5.25L5.193 6.4q-.328-.438-.099-.919.23-.48.797-.481h12.218q.567 0 .797.481.229.481-.098.919l-5.062 6.475v5.25a.85.85 0 0 1-.251.623.84.84 0 0 1-.622.252zM12 12.262l4.32-5.512H7.68z"
}))));
export { SvgFilterGreen as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9Ikljb24vRmlsdGVyIj4KPG1hc2sgaWQ9Im1hc2swXzU4MjNfMzk5MDAiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCI+CjxyZWN0IGlkPSJCb3VuZGluZyBib3giIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iI0Q5RDlEOSIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfNTgyM18zOTkwMCkiPgo8cGF0aCBpZD0iZmlsdGVyX2FsdCIgZD0iTTExLjEyNzIgMTlDMTAuODggMTkgMTAuNjcyNyAxOC45MTYxIDEwLjUwNTQgMTguNzQ4NEMxMC4zMzgxIDE4LjU4MDcgMTAuMjU0NSAxOC4zNzI5IDEwLjI1NDUgMTguMTI1VjEyLjg3NUw1LjE5MjUyIDYuNEM0Ljk3NDMzIDYuMTA4MzMgNC45NDE2IDUuODAyMDggNS4wOTQzMyA1LjQ4MTI1QzUuMjQ3MDcgNS4xNjA0MiA1LjUxMjUzIDUgNS44OTA3MiA1SDE4LjEwOTNDMTguNDg3NSA1IDE4Ljc1MjkgNS4xNjA0MiAxOC45MDU3IDUuNDgxMjVDMTkuMDU4NCA1LjgwMjA4IDE5LjAyNTcgNi4xMDgzMyAxOC44MDc1IDYuNEwxMy43NDU1IDEyLjg3NVYxOC4xMjVDMTMuNzQ1NSAxOC4zNzI5IDEzLjY2MTkgMTguNTgwNyAxMy40OTQ2IDE4Ljc0ODRDMTMuMzI3MyAxOC45MTYxIDEzLjEyIDE5IDEyLjg3MjggMTlIMTEuMTI3MlpNMTIgMTIuMjYyNUwxNi4zMjAxIDYuNzVINy42Nzk4N0wxMiAxMi4yNjI1WiIgZmlsbD0iIzA2Q0EzRCIvPgo8L2c+CjwvZz4KPC9zdmc+Cg==";